'use client';

import React from 'react';
import { FiInfo } from 'react-icons/fi';
import EconomicsPageContent, { type EconomicsPageConfig } from '../_shared/EconomicsPageContent';
import type { EconomicsPageData } from '../_shared/fetchEconomicsHistory';
import { CPI_SERIES } from './series';

const educationalContent = (
  <>
    <p>
      The <strong>Consumer Price Index (CPI)</strong> is a measure of the average change over time in
      the prices paid by urban consumers for a market basket of consumer goods and services. It is one
      of the most closely watched economic indicators and the most widely used measure of inflation.
    </p>
    <p>
      Published monthly by the <strong>U.S. Bureau of Labor Statistics (BLS)</strong>, the CPI measures
      price changes for items including food, housing, apparel, transportation, medical care,
      recreation, education, and communication.
    </p>
    <h3 className="text-base font-semibold text-bzgray-900 mt-4">Key Measures:</h3>
    <ul className="list-disc list-inside space-y-1">
      <li><strong>Headline CPI (YoY):</strong> Year-over-year change — the broadest inflation gauge, includes food and energy</li>
      <li><strong>Core CPI (YoY):</strong> Excludes food and energy — the Fed's preferred measure for underlying inflation trends</li>
      <li><strong>CPI (MoM):</strong> Month-over-month change — indicates the current pace of price movement</li>
      <li><strong>Core CPI (MoM):</strong> Month-over-month core change — closely watched for early trend signals</li>
    </ul>
    <h3 className="text-base font-semibold text-bzgray-900 mt-4">Why It Matters:</h3>
    <ul className="list-disc list-inside space-y-1">
      <li>The Federal Reserve monitors CPI alongside PCE to guide interest rate decisions</li>
      <li>Social Security benefits and tax brackets are adjusted based on CPI</li>
      <li>Financial markets react significantly to CPI surprises — especially Core CPI</li>
      <li>Businesses use CPI for wage negotiations and pricing decisions</li>
    </ul>
  </>
);

const config: EconomicsPageConfig = {
  pageId: 'cpi',
  name: 'Consumer Price Index (CPI)',
  shortName: 'CPI',
  subtitle: 'United States Inflation Data · Source: BLS via Benzinga Economic Calendar',
  chartTitle: 'CPI vs Core CPI',
  educationalTitle: 'What is the Consumer Price Index (CPI)?',
  Icon: FiInfo,
  source: 'U.S. Bureau of Labor Statistics',
  series: CPI_SERIES,
  educationalContent,
};

export default function CPIPageContent(props: EconomicsPageData) {
  return <EconomicsPageContent {...props} config={config} />;
}
